import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bandwidth-report',
  templateUrl: './bandwidth-report.component.html',
  styleUrls: ['./bandwidth-report.component.scss']
})
export class BandwidthReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
